import React from "react";

const Shape = () => {
  return (
    <>
      <div className="shape__one" />
      <div className="shape__two" />
      {/* <div className="shape__three" />
      <div className="shape__four" /> */}
    </>
  );
};

export default Shape;
